import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductStory from './components/ProductStory';
import FeatureCards from './components/FeatureCards';
import PrivacySection from './components/PrivacySection';
import FAQSection from './components/FAQSection';
import FooterUtilityBar from './components/FooterUtilityBar';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
function AppStoreRedirect() {
  useEffect(() => {
    window.location.href = 'https://apps.apple.com/us/app/emigo-better-texting/id6748092950';
  }, []);
  return null;
}
function HomePage() {
  return <>
      <Navbar data-id="element-0" />
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <ProductStory data-id="element-3" />
        <FeatureCards data-id="element-4" />
        <PrivacySection data-id="element-5" />
        <FAQSection data-id="element-6" />
        <FooterUtilityBar data-id="element-7" />
      </main>
    </>;
}
export function App() {
  document.title = 'Emigo — Text with clarity';
  return <BrowserRouter data-id="element-8">
      <div className="flex flex-col min-h-screen w-full" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-9">
        <Routes data-id="element-10">
          <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-14" />} data-id="element-13" />
          <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-16" />} data-id="element-15" />
          <Route path="/ig" element={<AppStoreRedirect data-id="element-18" />} data-id="element-17" />
          <Route path="/tiktok" element={<AppStoreRedirect data-id="element-20" />} data-id="element-19" />
        </Routes>
      </div>
    </BrowserRouter>;
}